// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-q"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 19L16 5.5C16 5.22386 15.7761 5 15.5 5L8.5 5C8.22386 5 8 5.22386 8 5.5L8 18.5C8 18.7761 8.22386 19 8.5 19H16ZM16 19H17.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersQIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-q',
    ref,
    icon: element,
  },
));

LettersQIcon.displayName = 'LettersQIcon';

export default LettersQIcon;
